import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (typeof window !== 'undefined' && import.meta.env.DEV) {
  // Diagnostic dev uniquement : ne pas laisser traîner l'URL/le préfixe de clé en prod.
  window.__autodjSupabaseEnv = {
    hasUrl: Boolean(url),
    hasAnonKey: Boolean(anonKey),
    url,
    anonKeyPrefix: anonKey ? `${anonKey.slice(0, 16)}...` : null,
  };
}

if (!url || !anonKey) {
  // Affiché uniquement en dev pour faciliter le diagnostic.
  // Ne jamais loguer la service_role key côté client.
  // eslint-disable-next-line no-console
  console.warn(
    '[supabase] VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY manquants. ' +
      'Ajoute-les dans .env.local et redémarre `npm run dev`.'
  );
}

// Verrou auth EN MÉMOIRE (sérialise les opérations auth dans l'onglet).
// Remplace le verrou `navigator.locks` par défaut de supabase-js : sur cette
// stack self-hosted, un onglet bloqué gardait le verrou exclusif
// `lock:sb-…-auth-token` et figeait getSession/signIn pour TOUT l'origine
// (« Chargement… » / « Connexion à la soirée… » infinis). L'app est mobile
// mono-onglet : aucune coordination cross-onglet nécessaire. Une chaîne de
// promesses suffit à éviter les rafraîchissements de token concurrents.
function makeInMemoryAuthLock() {
  let tail = Promise.resolve();
  return function authLock(_name, _acquireTimeout, fn) {
    const run = tail.then(() => fn());
    // La chaîne avance quoi qu'il arrive (succès comme échec), sans propager l'erreur.
    tail = run.then(
      () => undefined,
      () => undefined,
    );
    return run;
  };
}

export const supabase = createClient(url ?? '', anonKey ?? '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    lock: makeInMemoryAuthLock(),
  },
  realtime: {
    params: { eventsPerSecond: 10 },
  },
});
